import React, { FC } from 'react';
import userDefaultImage from '../../../../assets/images/user-default.jpg';

interface IProfileCard {
  deviceInfo: any;
  loading: boolean;
}

export const ProfileCard: FC<IProfileCard> = ({ deviceInfo, loading }) => {
  const { status, picture, name } = deviceInfo?.profile || {};

  if (loading) {
    return (
      <div className="flex items-center space-x-4 animate-pulse">
        {/* Profile Picture Skeleton */}
        <div className="flex-shrink-0">
          <div className="h-20 w-20 rounded-full bg-gray-200 border-2 border-gray-200 shadow-sm dark:bg-gray-700 dark:border-gray-600"></div>
        </div>

        {/* Profile Info Skeleton */}
        <div className="flex-1 min-w-0">
          {/* Profile Name Skeleton */}
          <div className="h-5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>

          {/* About/Status Skeleton */}
          <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 w-20"></div>
        </div>

        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-4">
      {/* Profile Picture */}
      <div className="flex-shrink-0">
        <img
          src={picture?.imgFull || userDefaultImage}
          alt={name}
          className="h-20 w-20 rounded-full object-cover border-2 border-gray-200 shadow-sm"
        />
      </div>

      {/* Profile Info */}
      <div className="flex-1 min-w-0">
        {/* Profile Name */}
        <div className="text-lg font-semibold text-gray-900 mb-1">{name}</div>

        {/* About/Status */}
        <div className="text-base text-gray-500">{status}</div>
      </div>
    </div>
  );
};
